import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export const usePWABannerPrompt = (): [
  BeforeInstallPromptEvent | null,
  () => Promise<void> | undefined,
] => {
  const { t } = useTranslation()
  const [prompt, setPrompt] = useState<BeforeInstallPromptEvent | null>(null)

  const promptToInstall = () => {
    if (prompt) {
      return prompt.prompt()
    }
    return Promise.reject(new Error(t("pwa.installPromptError")))
  }

  useEffect(() => {
    const ready = (e: BeforeInstallPromptEvent) => {
      setPrompt(e)
    }

    if (typeof window.beforeInstallPromptEvent === "undefined") {
      window.addEventListener("beforeinstallprompt", ready)
    } else {
      ready(window.beforeInstallPromptEvent)
    }

    return () => {
      window.removeEventListener("beforeinstallprompt", ready)
    }
  }, [])

  return [prompt, promptToInstall]
}
